import { tEnum } from "@components/i18n";
import { CamelCaseKeys } from "@utils/typescript";
import { UserLess } from "./User";

export enum ActionRequestSubjectTypes {
  InsuranceClaim = 'InsuranceClaim',
}

export enum ActionRequestStatuses {
  Open = 'open',
  Resolved = 'resolved',
}

export type ActionRequest = CamelCaseKeys<{
  id: number;
  status: ActionRequestStatuses;
  title: string;
  body: string;
  created_at: number;
  requester: UserLess;
}>;

const ACTION_REQUEST_STATUSES_VARIANTS_MAPPING = {
  [ActionRequestStatuses.Open]: 'info',
  [ActionRequestStatuses.Resolved]: 'secondary',
};

export const tActionRequestStatus = (status: ActionRequestStatuses) => tEnum('actionRequestStatuses', status);
export const getActionRequestStatusVariant = (status: ActionRequestStatuses): string => ACTION_REQUEST_STATUSES_VARIANTS_MAPPING[status];
